import {Maybe, SubscriptionFieldsFragment, SubscriptionStatus} from 'api/generated';

export const getIntervalLabel = (subscription: SubscriptionFieldsFragment | undefined | null) => {
  if (!subscription) return;
  const {interval, intervalCount} = subscription;
  if (!interval || !intervalCount) return;
  const intervalLabel = interval + (intervalCount > 1 ? 's' : '');
  if (intervalCount <= 1) return intervalLabel;
  return `${intervalCount} ${intervalLabel}`;
};

export const canPause = (subscription: SubscriptionFieldsFragment | undefined | null) => {
  if (!subscription) return;
  return (
    subscription.status === SubscriptionStatus.ACTIVE &&
    !subscription.pauseAtPeriodEnd &&
    !subscription.cancelAtPeriodEnd
  );
};

export const canResume = (subscription: SubscriptionFieldsFragment | undefined | null) => {
  if (!subscription) return;
  return (
    subscription.status === SubscriptionStatus.PAUSED ||
    ([SubscriptionStatus.ACTIVE, SubscriptionStatus.TRIALING].includes(subscription.status) &&
      (subscription.pauseAtPeriodEnd || subscription.cancelAtPeriodEnd))
  );
};

export const canCancel = (subscription: SubscriptionFieldsFragment | undefined | null) => {
  if (!subscription) return;
  return (
    [
      SubscriptionStatus.ACTIVE,
      SubscriptionStatus.PAUSED,
      SubscriptionStatus.TRIALING,
      SubscriptionStatus.PAST_DUE
    ].includes(subscription.status) && !subscription.cancelAtPeriodEnd
  );
};

export const canUpdate = (subscription: SubscriptionFieldsFragment | undefined | null) => {
  if (!subscription) return;
  return (
    [
      SubscriptionStatus.ACTIVE,
      SubscriptionStatus.PENDING,
      SubscriptionStatus.TRIALING,
      SubscriptionStatus.PAST_DUE
    ].includes(subscription.status) &&
    !subscription.pauseAtPeriodEnd &&
    !subscription.cancelAtPeriodEnd
  );
};

export const canSendSubscriptionStatus = (subscription?: Maybe<SubscriptionFieldsFragment>) => {
  if (!subscription) return false;
  return [
    SubscriptionStatus.ACTIVE,
    SubscriptionStatus.PAUSED,
    SubscriptionStatus.TRIALING,
    SubscriptionStatus.PENDING,
    SubscriptionStatus.PAST_DUE,
    SubscriptionStatus.EXPIRED
  ].includes(subscription.status);
};
